<template>
  <div class="header flex justify-center items-center px-16">
    <div class="container mx-auto w-screen">
      <div class="grid grid-cols-1 lg:grid-cols-2 gap-8 items-stretch py-8">
        <div class="left-side flex justify-center items-center">
          <img src="../assets/image/Cindy.svg" alt="" />
        </div>
        <div class="right-side">
          <p
            class="position text-center lg:text-left font-bold text-xl lg:text-3xl pb-3"
          >
            ABOUT ME
          </p>
          <p
            class="position text-center lg:text-left text-sm lg:text-lg font-medium"
          >
            Hello, my name is Cindy from the 2018 Department of Informatics at
            Multimedia Nusantara University. I am someone who loves technology
            and is always studying technology that always growing,a person who
            never gives up, always evaluates myself to be better and works hard.
            I'm looking forward to join a progressive tech company where I could
            fully harness my technical skills.
          </p>
          <div class="detail flex items-center py-2">
            <a href="https://www.instagram.com/cindyelsanjaya/"
              ><img class="w-7 h-7" src="../assets/image/instagram.svg" alt=""
            /></a>
            <p class="position text-sm lg:text-base font-medium px-2">
              @cindyelsanjaya
            </p>
          </div>
          <div class="detail flex items-center py-2">
            <a
              href="https://www.linkedin.com/in/yohana-cindy-elsanjaya-307a9b204/"
              ><img class="w-7 h-7" src="../assets/image/linkin.svg" alt=""
            /></a>
            <p class="position text-sm lg:text-base font-medium px-2">
              Yohana Cindy Elsanjaya
            </p>
          </div>
          <div class="detail flex items-center py-2">
            <a href="mailto:cindyelsanjaya@gmail.com"
              ><img class="w-7 h-7" src="../assets/image/email.svg" alt=""
            /></a>
            <p class="position text-sm lg:text-base font-medium px-2">
              cindyelsanjaya@gmail.com
            </p>
          </div>
          <div class="detail flex items-center py-2">
            <a href="https://github.com/ciel9"
              ><img class="w-7 h-7" src="../assets/image/github.svg" alt=""
            /></a>
            <p class="position text-sm lg:text-base font-medium px-2">ciel09</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,300;0,600;1,400&family=Poppins:ital,wght@0,300;0,600;1,300&family=Roboto&display=swap");

.position {
  font-family: "Montserrat", sans-serif;
}
</style>
